import { RouteRecordRaw, createRouter, createWebHistory } from 'vue-router'
import store from '../store'
import { meta } from '@/utils/meta'
import Header from '@/components/genenral/Header.vue'
import HeaderRegister from '@/components/genenral/HeaderRegister.vue'
import Footer from '@/components/genenral/Footer.vue'
import Home from '@/views/Home.vue'
import Login from '@/views/Login.vue'
import registerForm from '@/views/register/Index.vue'
import registerUserCategory from '@/views/register/UserCategory.vue'
import registerArea from '@/views/register/Area.vue'
import registerTerms from '@/views/register/Terms.vue'
import registerProfile from '@/views/register/Profile.vue'
import registerConfirm from '@/views/register/Confirm.vue'
import registerSelect from '@/views/register/Select.vue'
import registerThanks from '@/views/register/Thanks.vue'
import registerEventsForm from '@/views/register/events/Index.vue'
import registerEventsUserCategory from '@/views/register/events/UserCategory.vue'
import registerEventsArea from '@/views/register/events/Area.vue'
import registerEventsTerms from '@/views/register/events/Terms.vue'
import registerEventsProfile from '@/views/register/events/Profile.vue'
import registerEventsConfirm from '@/views/register/events/Confirm.vue'
import registerEventsSelect from '@/views/register/events/Select.vue'
import RegisterEventsThanks from '@/views/register/events/Thanks.vue'
import hospitalsList from '@/views/hospitals/List.vue'
import latterList from '@/views/latter/List.vue'
import eventsList from '@/views/events/List.vue'
import Archive from '@/views/events/Archive.vue'
import magazinesMatchingDetail from '@/views/magazines/matching/Detail.vue'
import MagazinesSeries from '@/views/magazines/Series.vue'
import MagazinesSpecial from '@/views/magazines/Special.vue'
import MagazinesCategory from '@/views/magazines/Category.vue'
import MagazinesKeyword from '@/views/magazines/Keyword.vue'
import MagazinesDetail from '@/views/magazines/Detail.vue'
import examMaster from '@/views/magazines/exam/Master.vue'
import examMasterList from '@/views/magazines/exam/MasterList.vue'
import examCbt from '@/views/magazines/exam/Cbt.vue'
import examCbtDetail from '@/views/magazines/exam/CbtDetail.vue'
import examCbtFail from '@/views/magazines/exam/CbtFail.vue'
import examCbtResult from '@/views/magazines/exam/CbtResult.vue'
import examCbtAllResult from '@/views/magazines/exam/CbtAllResult.vue'
import notFound from '@/views/NotFound.vue'
import systemError from '@/views/SystemError.vue'
// import reports from '@/views/Reports.vue'
// import reportsDetail from '@/views/reports/Detail.vue'
// import voices from '@/views/Voices.vue'
import news from '@/views/news/Index.vue'
import newsYear from '@/views/news/Year.vue'
import newsDetail from '@/views/news/Detail.vue'
import faq from '@/views/faq/Index.vue'
import faqList from '@/views/faq/List.vue'
import passwordReset from '@/views/password/Index.vue'
import passwordResetSendmail from '@/views/password/Sendmail.vue'
import passwordResetNewPassword from '@/views/password/Newpassword.vue'
import passwordResetComplete from '@/views/password/Complete.vue'

const baseTitle = document.title
const metaDesc = document.querySelector('meta[name="description"]')
const baseDesc = metaDesc ? metaDesc.getAttribute('content') : ''

const routes: Array<RouteRecordRaw> = [
  {
    path: '',
    name: 'Home',
    components: {
      default: Home,
      header: Header,
      footer: Footer
    }
  },
  {
    path: '/login',
    name: 'Login',
    components: {
      default: Login,
      header: HeaderRegister,
      footer: Footer
    },
    meta: meta.login
  },
  {
    path: '/register',
    name: 'Register',
    components: {
      default: registerForm,
      header: HeaderRegister
    },
    meta: meta.register,
    children: [
      {
        path: '/register/user_category',
        component: registerUserCategory
      },
      {
        path: '/register/area',
        component: registerArea
      },
      {
        path: '/register/terms',
        component: registerTerms
      },
      {
        path: '/register/select',
        component: registerSelect
      },
      {
        path: '/register/profile',
        component: registerProfile
      },
      {
        path: '/register/confirm',
        component: registerConfirm,
        meta: meta.registerConfirm
      }
    ]
  },
  {
    path: '/register/thanks',
    name: 'RegisterThanks',
    components: {
      default: registerThanks,
      header: HeaderRegister,
      footer: Footer
    },
    meta: meta.registerThanks
  },
  {
    path: '/register/events',
    name: 'RegisterEvents',
    components: {
      default: registerEventsForm,
      header: HeaderRegister
    },
    meta: meta.register,
    children: [
      {
        path: '/register/events/user_category',
        component: registerEventsUserCategory
      },
      {
        path: '/register/events/area',
        component: registerEventsArea
      },
      {
        path: '/register/events/terms',
        component: registerEventsTerms
      },
      {
        path: '/register/events/select',
        component: registerEventsSelect
      },
      {
        path: '/register/events/profile',
        component: registerEventsProfile
      },
      {
        path: '/register/events/confirm',
        component: registerEventsConfirm
      }
    ]
  },
  {
    path: '/register/events/thanks',
    name: 'RegisterEventsThanks',
    components: {
      default: RegisterEventsThanks,
      header: HeaderRegister,
      footer: Footer
    },
    meta: meta.registerThanks
  },
  {
    path: '/search/hospital/list',
    name: 'HospitalsListAll',
    components: {
      default: hospitalsList,
      header: Header,
      footer: Footer
    },
    meta: meta.hospitalsList
  },
  {
    path: '/search/hospital/list/:pathMatch(.*)',
    name: 'HospitalsList',
    components: {
      default: hospitalsList,
      header: Header,
      footer: Footer
    },
    meta: meta.hospitalsList
  },
  {
    path: '/search/latter/list:pathMatch(.*)',
    name: 'LatterList',
    components: {
      default: latterList,
      header: Header,
      footer: Footer
    },
    meta: meta.latterList
  },
  {
    path: '/search/hospital/detail/:id',
    name: 'HospitalsDetail',
    components: {
      default: () =>
        import(
          /* webpackChunkName: "hospitalsDetail" */ '../views/hospitals/Detail.vue'
        ),
      header: Header,
      footer: Footer
    },
    meta: meta.hospitalsDetail,
    props: {
      header: {
        sm: false
      }
    }
  },
  {
    path: '/visit_application',
    name: 'VisitApplication',
    components: {
      default: () =>
        import(
          /* webpackChunkName: "VisitApplication" */ '../views/visitApplication/Index.vue'
        ),
      header: Header,
      footer: Footer
    },
    children: [
      {
        path: '/visit_application/:id/input',
        component: () =>
          import(
            /* webpackChunkName: "VisitApplication" */ '../views/visitApplication/Input.vue'
          ),
        meta: meta.visitApplicationInput
      },
      {
        path: '/visit_application/:id/confirm',
        component: () =>
          import(
            /* webpackChunkName: "VisitApplication" */ '../views/visitApplication/Confirm.vue'
          ),
        meta: meta.visitApplicationConfirm
      },
      {
        path: '/visit_application/:id/thanks',
        component: () =>
          import(
            /* webpackChunkName: "VisitApplication" */ '../views/visitApplication/Thanks.vue'
          ),
        meta: meta.visitApplicationThanks
      }
    ]
  },
  {
    path: '/visit_application_latter',
    name: 'VisitApplicationLatter',
    components: {
      default: () =>
        import(
          /* webpackChunkName: "VisitApplicationLatter" */ '../views/visitApplicationLatter/Index.vue'
        ),
      header: Header,
      footer: Footer
    },
    children: [
      {
        path: '/visit_application_latter/:id/input',
        component: () =>
          import(
            /* webpackChunkName: "VisitApplicationLatter" */ '../views/visitApplicationLatter/Input.vue'
          ),
        meta: meta.visitApplicationLatterInput
      },
      {
        path: '/visit_application_latter/:id/confirm',
        component: () =>
          import(
            /* webpackChunkName: "VisitApplicationLatter" */ '../views/visitApplicationLatter/Confirm.vue'
          ),
        meta: meta.visitApplicationLatterConfirm
      },
      {
        path: '/visit_application_latter/:id/thanks',
        component: () =>
          import(
            /* webpackChunkName: "VisitApplicationLatter" */ '../views/visitApplicationLatter/Thanks.vue'
          ),
        meta: meta.visitApplicationLatterThanks
      }
    ]
  },
  {
    path: '/terms',
    name: 'Terms',
    components: {
      default: () =>
        import(/* webpackChunkName: "terms" */ '../views/Terms.vue'),
      header: Header,
      footer: Footer
    },
    meta: meta.terms
  },
  {
    path: '/privacy_policy',
    name: 'PrivacyPolicy',
    components: {
      default: () =>
        import(
          /* webpackChunkName: "privacyPolicy" */ '../views/PrivacyPolicy.vue'
        ),
      header: Header,
      footer: Footer
    },
    meta: meta.privacyPolicy
  },
  {
    path: '/lp/services',
    name: 'Services',
    components: {
      default: () =>
        import(/* webpackChunkName: "services" */ '../views/lp/Services.vue'),
      header: Header,
      footer: Footer
    },
    meta: meta.lpService
  },
  {
    path: '/lp/supporters',
    name: 'Supporters',
    components: {
      default: () =>
        import(
          /* webpackChunkName: "supporters" */ '../views/lp/Supporters.vue'
        ),
      header: Header,
      footer: Footer
    },
    meta: meta.lpSupporters
  },
  {
    path: '/lp/hpcr',
    name: 'Hpcr',
    components: {
      default: () =>
        import(/* webpackChunkName: "hpcr" */ '../views/lp/Hpcr.vue'),
      header: Header,
      footer: Footer
    },
    meta: meta.lpHpcr
  },
  {
    path: '/lp/etc/:slug',
    name: 'LpEtc',
    components: {
      default: () =>
        import(/* webpackChunkName: "lpEtc" */ '../views/lp/etc/Detail.vue'),
      header: Header,
      footer: Footer
    },
    meta: meta.lpEtc
  },
  {
    path: '/lp/etc/:slug',
    name: 'LpEtc',
    components: {
      default: () =>
        import(/* webpackChunkName: "lpEtc" */ '../views/lp/etc/Detail.vue'),
      header: Header,
      footer: Footer
    },
    meta: meta.lpEtc
  },
  {
    path: '/password',
    name: 'Reset',
    components: {
      default: passwordReset,
      header: Header,
      footer: Footer
    },
    meta: meta.password
  },
  {
    path: '/password/sendmail',
    name: 'ResetSendmail',
    components: {
      default: passwordResetSendmail,
      header: Header,
      footer: Footer
    },
    meta: meta.passwordSendmail
  },
  {
    path: '/password/newpassword',
    name: 'ResetNewPassword',
    components: {
      default: passwordResetNewPassword,
      header: Header,
      footer: Footer
    },
    meta: meta.passwordInput
  },
  {
    path: '/password/complete',
    name: 'ResetComplete',
    components: {
      default: passwordResetComplete,
      header: Header,
      footer: Footer
    },
    meta: meta.passwordComplete
  },
  {
    path: '/document_request',
    name: 'documentRequest',
    components: {
      default: () =>
        import(
          /* webpackChunkName: "DocumentRequest" */ '../views/documentRequest/Index.vue'
        ),
      header: Header,
      footer: Footer
    },
    children: [
      {
        path: '/document_request/:id/input',
        component: () =>
          import(
            /* webpackChunkName: "DocumentRequest" */ '../views/documentRequest/Input.vue'
          ),
        meta: meta.documentRequestInput
      },
      {
        path: '/document_request/:id/confirm',
        component: () =>
          import(
            /* webpackChunkName: "DocumentRequest" */ '../views/documentRequest/Confirm.vue'
          ),
        meta: meta.documentRequestConfirm
      },
      {
        path: '/document_request/:id/thanks',
        component: () =>
          import(
            /* webpackChunkName: "DocumentRequest" */ '../views/documentRequest/Thanks.vue'
          ),
        meta: meta.documentRequestThanks
      }
    ]
  },
  {
    path: '/document_request_latter',
    name: 'documentRequestLatter',
    components: {
      default: () =>
        import(
          /* webpackChunkName: "DocumentRequestLatter" */ '../views/documentRequestLatter/Index.vue'
        ),
      header: Header,
      footer: Footer
    },
    children: [
      {
        path: '/document_request_latter/:id/input',
        component: () =>
          import(
            /* webpackChunkName: "DocumentRequestLatter" */ '../views/documentRequestLatter/Input.vue'
          ),
        meta: meta.documentRequestLatterInput
      },
      {
        path: '/document_request_latter/:id/confirm',
        component: () =>
          import(
            /* webpackChunkName: "DocumentRequestLatter" */ '../views/documentRequestLatter/Confirm.vue'
          ),
        meta: meta.documentRequestLatterConfirm
      },
      {
        path: '/document_request_latter/:id/thanks',
        component: () =>
          import(
            /* webpackChunkName: "DocumentRequestLatter" */ '../views/documentRequestLatter/Thanks.vue'
          ),
        meta: meta.documentRequestLatterThanks
      }
    ]
  },
  {
    path: '/mypage',
    name: 'MyPage',
    components: {
      default: () =>
        import(/* webpackChunkName: "mypage" */ '../views/mypage/Index.vue'),
      header: Header,
      footer: Footer
    },
    meta: meta.mypage
  },
  {
    path: '/mypage/bookmark/list',
    name: 'MypageBookmarkList',
    components: {
      default: () =>
        import(
          /* webpackChunkName: "mypage" */ '../views/mypage/BookmarkList.vue'
        ),
      header: Header,
      footer: Footer
    },
    meta: meta.mypageBookmark
  },
  {
    path: '/mypage/visit_application',
    name: 'MypageVisitApplication',
    components: {
      default: () =>
        import(
          /* webpackChunkName: "mypageList" */ '../views/mypage/VisitApplication.vue'
        ),
      header: Header,
      footer: Footer
    },
    children: [
      {
        path: '/mypage/visit_application/list',
        component: () =>
          import(
            /* webpackChunkName: "mypageList" */ '../views/mypage/VisitApplicationList.vue'
          ),
        meta: meta.mypageVisitApplicationList
      },
      {
        path: '/mypage/visit_application/detail/:id',
        component: () =>
          import(
            /* webpackChunkName: "mypageList" */ '../views/mypage/VisitApplicationDetail.vue'
          ),
        meta: meta.mypageVisitApplicationDetail
      }
    ]
  },
  {
    path: '/mypage/document_request',
    name: 'DocumentRequest',
    components: {
      default: () =>
        import(
          /* webpackChunkName: "mypageList" */ '../views/mypage/DocumentRequest.vue'
        ),
      header: Header,
      footer: Footer
    },
    children: [
      {
        path: '/mypage/document_request/list',
        component: () =>
          import(
            /* webpackChunkName: "mypageList" */ '../views/mypage/DocumentRequestList.vue'
          ),
        meta: meta.mypageDocumentRequestList
      },
      {
        path: '/mypage/document_request/detail/:id',
        component: () =>
          import(
            /* webpackChunkName: "mypageList" */ '../views/mypage/DocumentRequestDetail.vue'
          ),
        meta: meta.mypageDocumentRequestDetail
      }
    ]
  },
  {
    path: '/mypage/event/list',
    name: 'MypageEventList',
    components: {
      default: () =>
        import(
          /* webpackChunkName: "mypageList" */ '../views/mypage/EventList.vue'
        ),
      header: Header,
      footer: Footer
    },
    meta: meta.mypageEvent
  },
  {
    path: '/mypage/user',
    name: 'MyPageUser',
    components: {
      default: () =>
        import(/* webpackChunkName: "mypageUser" */ '../views/mypage/User.vue'),
      header: Header,
      footer: Footer
    },
    children: [
      {
        path: '/mypage/user/profile',
        component: () =>
          import(
            /* webpackChunkName: "mypageUser" */ '../views/mypage/UserProfile.vue'
          ),
        meta: meta.myPageUserProfile
      },
      {
        path: '/mypage/user/profile/:type',
        component: () =>
          import(
            /* webpackChunkName: "mypageUser" */ '../views/mypage/UserProfileEdit.vue'
          ),
        meta: meta.myPageUserProfileEdit
      }
    ]
  },
  {
    path: '/mypage/saved_search_conditions/list',
    name: 'MypageSavedCond',
    components: {
      default: () =>
        import(
          /* webpackChunkName: "mypage" */ '../views/mypage/SavedCond.vue'
        ),
      header: Header,
      footer: Footer
    },
    meta: meta.mypageSavedCond
  },
  {
    path: '/mypage/checked_in/visit/:id',
    name: 'MypageCheckin',
    components: {
      default: () =>
        import(
          /* webpackChunkName: "mypageCheckin" */ '../views/mypage/Checkin.vue'
        ),
      header: Header,
      footer: Footer
    },
    meta: meta.mypageCheckin
  },
  {
    path: '/mypage/leave/',
    name: 'MypageLeave',
    components: {
      default: () =>
        import(
          /* webpackChunkName: "mypageLeave" */ '../views/mypage/Leave.vue'
        ),
      header: Header,
      footer: Footer
    },
    children: [
      {
        path: '/mypage/leave/input/',
        name: 'MyPageLeaveInput',
        components: {
          default: () =>
            import(
              /* webpackChunkName: "mypageLeave" */ '../views/mypage/LeaveInput.vue'
            ),
          header: Header,
          footer: Footer
        },
        meta: meta.mypageLeaveInput
      },
      {
        path: '/mypage/leave/confirm/',
        name: 'MyPageLeaveConfirm',
        components: {
          default: () =>
            import(
              /* webpackChunkName: "mypageLeave" */ '../views/mypage/LeaveConfirm.vue'
            ),
          header: Header,
          footer: Footer
        },
        meta: meta.mypageLeaveConfirm
      },
      {
        path: '/mypage/leave/thanks/',
        name: 'MyPageLeaveThanks',
        components: {
          default: () =>
            import(
              /* webpackChunkName: "mypageLeave" */ '../views/mypage/LeaveThanks.vue'
            ),
          header: Header,
          footer: Footer
        },
        meta: meta.mypageLeaveThanks
      }
    ]
  },
  {
    path: '/events/list',
    name: 'EventsList',
    components: {
      default: eventsList,
      header: Header,
      footer: Footer
    },
    meta: meta.eventList
  },

  {
    path: '/events/detail/:id',
    name: 'EventsDetail',
    components: {
      default: () =>
        import(
          /* webpackChunkName: "eventsDetail" */ '../views/events/Detail.vue'
        ),
      header: Header,
      footer: Footer
    }
  },
  {
    path: '/events/reserve',
    name: 'EventsReserve',
    components: {
      default: () =>
        import(
          /* webpackChunkName: "eventsReserve" */ '../views/events/reserve/Index.vue'
        ),
      header: Header,
      footer: Footer
    },
    children: [
      {
        path: '/events/reserve/input/:id',
        component: () =>
          import(
            /* webpackChunkName: "eventsReserve" */ '../views/events/reserve/Input.vue'
          ),
        meta: meta.eventsReserveInput
      },
      {
        path: '/events/reserve/confirm/:id',
        component: () =>
          import(
            /* webpackChunkName: "eventsReserve" */ '../views/events/reserve/Confirm.vue'
          ),
        meta: meta.eventsReserveConfirm
      },
      {
        path: '/events/reserve/thanks/:id',
        component: () =>
          import(
            /* webpackChunkName: "eventsReserve" */ '../views/events/reserve/Thanks.vue'
          ),
        meta: meta.eventsReserveThanks
      }
    ]
  },
  {
    path: '/events/archives/list',
    name: 'EventsArchivesList',
    components: {
      default: Archive,
      header: Header,
      footer: Footer
    },
    meta: meta.eventArchiveList
  },
  // {
  //   path: '/reports',
  //   name: 'Reports',
  //   components: {
  //     default: reports,
  //     header: Header,
  //     footer: Footer
  //   }
  // },
  // {
  //   path: '/reports/detail',
  //   name: 'ReportsDetail',
  //   components: {
  //     default: reportsDetail,
  //     header: Header,
  //     footer: Footer
  //   }
  // },
  // {
  //   path: '/voices',
  //   name: 'Voices',
  //   components: {
  //     default: voices,
  //     header: Header,
  //     footer: Footer
  //   }
  // },
  {
    path: '/magazines/matching/detail/:slug',
    name: 'MagazinesMatchingDetail',
    components: {
      default: magazinesMatchingDetail,
      header: Header,
      footer: Footer
    },
    meta: meta.magazinesMatchingDetail
  },
  {
    path: '/magazines/series/',
    name: 'magazinesSeries',
    components: {
      default: MagazinesSeries,
      header: Header,
      footer: Footer
    },
    meta: meta.magazinesSeries
  },
  {
    path: '/magazines/series/category/:id',
    name: 'magazinesSeriesCategory',
    components: {
      default: MagazinesCategory,
      header: Header,
      footer: Footer
    },
    meta: meta.magazinesSeriesCategory
  },
  {
    path: '/magazines/special/',
    name: 'magazinesSpecial',
    components: {
      default: MagazinesSpecial,
      header: Header,
      footer: Footer
    },
    meta: meta.magazinesSpecial
  },
  {
    path: '/magazines/special/category/:id',
    name: 'magazinesSpecialCategory',
    components: {
      default: MagazinesCategory,
      header: Header,
      footer: Footer
    },
    meta: meta.magazinesSpecialCategory
  },
  {
    path: '/magazines/keyword/:id',
    name: 'magazinesKeyword',
    components: {
      default: MagazinesKeyword,
      header: Header,
      footer: Footer
    },
    meta: meta.magazinesKeyword
  },
  {
    path: '/magazines/special/detail/:id',
    name: 'magazinesDetail',
    components: {
      default: MagazinesDetail,
      header: Header,
      footer: Footer
    },
    meta: meta.magazinesDetail
  },
  {
    path: '/magazines/exam/master/',
    name: 'examMaster',
    components: {
      default: examMaster,
      header: Header,
      footer: Footer
    },
    meta: meta.examMaster
  },
  {
    path: '/magazines/exam/master/detail/:id',
    name: 'examMasterDetail',
    components: {
      default: examMaster,
      header: Header,
      footer: Footer
    },
    meta: meta.examMasterDetail
  },
  {
    path: '/magazines/exam/master/list/:categoryId',
    name: 'examMasterList',
    components: {
      default: examMasterList,
      header: Header,
      footer: Footer
    },
    meta: meta.examMasterList
  },
  {
    path: '/magazines/exam/cbt/',
    name: 'examCbt',
    components: {
      default: examCbt,
      header: Header,
      footer: Footer
    },
    meta: meta.examCbt
  },
  {
    path: '/magazines/exam/cbt/:category/detail/:qno',
    name: 'examCbtDetail',
    components: {
      default: examCbtDetail,
      header: Header,
      footer: Footer
    },
    meta: meta.examCbtDetail
  },
  {
    path: '/magazines/exam/cbt/:category/fail',
    name: 'examCbtFail',
    components: {
      default: examCbtFail,
      header: Header,
      footer: Footer
    },
    meta: meta.examCbtFail
  },
  {
    path: '/magazines/exam/cbt/:category/result',
    name: 'examCbtResult',
    components: {
      default: examCbtResult,
      header: Header,
      footer: Footer
    },
    meta: meta.examCbtResult
  },
  {
    path: '/magazines/exam/cbt/all/result',
    name: 'examCbtAllResult',
    components: {
      default: examCbtAllResult,
      header: Header,
      footer: Footer
    },
    meta: meta.examCbtAllResult
  },
  {
    path: '/news',
    name: 'News',
    components: {
      default: news,
      header: Header,
      footer: Footer
    },
    meta: meta.news
  },
  {
    path: '/news/:page',
    name: 'NewsPage',
    components: {
      default: news,
      header: Header,
      footer: Footer
    },
    meta: meta.news
  },
  {
    path: '/news/year/:year',
    name: 'NewsYear',
    components: {
      default: newsYear,
      header: Header,
      footer: Footer
    },
    meta: meta.newsDetail
  },
  {
    path: '/news/year/:year/:page',
    name: 'NewsYearPage',
    components: {
      default: newsYear,
      header: Header,
      footer: Footer
    },
    meta: meta.newsDetail
  },
  {
    path: '/news/detail/:id',
    name: 'NewsDetail',
    components: {
      default: newsDetail,
      header: Header,
      footer: Footer
    },
    meta: meta.newsDetail
  },
  {
    path: '/faq',
    name: 'Faq',
    components: {
      default: faq,
      header: Header,
      footer: Footer
    },
    meta: meta.faq
  },
  {
    path: '/faq/list/:category',
    name: 'FaqList',
    components: {
      default: faqList,
      header: Header,
      footer: Footer
    },
    meta: meta.faqList
  },
  {
    path: '/contact',
    name: 'Contact',
    components: {
      default: () =>
        import(/* webpackChunkName: "contact" */ '../views/contact/Index.vue'),
      header: Header,
      footer: Footer
    },
    children: [
      {
        path: '/contact/input',
        component: () =>
          import(
            /* webpackChunkName: "contact" */ '../views/contact/Input.vue'
          ),
        meta: meta.contactInput
      },
      {
        path: '/contact/confirm',
        component: () =>
          import(
            /* webpackChunkName: "contact" */ '../views/contact/Confirm.vue'
          ),
        meta: meta.contactConfirm
      },
      {
        path: '/contact/thanks',
        component: () =>
          import(
            /* webpackChunkName: "contact" */ '../views/contact/Thanks.vue'
          ),
        meta: meta.contactThanks
      }
    ]
  },
  {
    path: '/guide',
    name: 'Guide',
    components: {
      default: () =>
        import(/* webpackChunkName: "guide" */ '../views/guide/Index.vue'),
      header: Header,
      footer: Footer
    },
    meta: meta.guide
  },
  {
    path: '/sitemap/',
    name: 'SiteMap',
    components: {
      default: () =>
        import(/* webpackChunkName: "sitemap" */ '../views/SiteMap.vue'),
      header: Header,
      footer: Footer
    },
    meta: meta.sitemap
  },
  {
    path: '/procedure',
    name: 'Procedure',
    components: {
      default: () =>
        import(
          /* webpackChunkName: "procedure" */ '../views/procedure/Index.vue'
        ),
      header: HeaderRegister
    },
    children: [
      {
        path: '/procedure/register',
        component: () =>
          import(
            /* webpackChunkName: "procedure" */ '../views/procedure/Register.vue'
          )
      },
      {
        path: '/procedure/send',
        component: () =>
          import(
            /* webpackChunkName: "procedure" */ '../views/procedure/Send.vue'
          )
      },
      {
        path: '/procedure/register/:token',
        component: () =>
          import(
            /* webpackChunkName: "procedure" */ '../views/procedure/Token.vue'
          )
      },
      {
        path: '/procedure/confirm',
        component: () =>
          import(
            /* webpackChunkName: "procedure" */ '../views/procedure/Confirm.vue'
          )
      },
      {
        path: '/procedure/complete',
        component: () =>
          import(
            /* webpackChunkName: "procedure" */ '../views/procedure/Complete.vue'
          )
      }
    ]
  },
  {
    path: '/lp/sp/event20210504',
    name: 'lpSpEvent20210504',
    components: {
      default: () =>
        import(/* webpackChunkName: "lp" */ '../views/lp/sp/Event20210504.vue'),
      header: Header,
      footer: Footer
    },
    meta: meta.lpSpEvent20210504
  },
  {
    path: '/lp/sp/event20210718',
    name: 'lpSpEvent20210718',
    components: {
      default: () =>
        import(/* webpackChunkName: "lp" */ '../views/lp/sp/Event20210718.vue'),
      header: Header,
      footer: Footer
    },
    meta: meta.lpSpEvent20210718
  },
  {
    path: '/conts/social/interview01.html',
    redirect: '/magazines/special/detail/390'
  },
  {
    path: '/conts/social/interview02.html',
    redirect: '/magazines/special/detail/387'
  },
  {
    path: '/conts/social/interview03.html',
    redirect: '/magazines/special/detail/237'
  },
  {
    path: '/lp/cp/events',
    redirect: '/lp/etc/newregist'
  },
  {
    path: '/500',
    name: 'SystemError',
    components: {
      default: systemError,
      header: HeaderRegister
    },
    meta: meta.notFound
  },
  {
    path: '/:pathMatch(.*)',
    name: 'NotFound',
    components: {
      default: notFound,
      header: HeaderRegister,
      footer: Footer
    },
    meta: meta.notFound
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    }
    return { top: 0 }
  }
})

router.beforeEach(async (to, from, next) => {
  // ページ遷移に時間がかかる場合にローディングを出す
  if (store.state.isInitialized) {
    if (to.meta.loader) store.commit('showLoading')
  }

  if (!store.state.isInitialized) {
    // ユーザー情報取得処理の実行
    await store.dispatch('getUserInfo')

    // 初回ローディングを消す
    if (!to.meta.loader) store.commit('closeLoading')
  }

  // ログインが必要なページでログインしていなければログイン画面に遷移
  if (to.meta.requireLogin && !store.state.isLogin) {
    next({ path: '/login', query: { q: to.path } })
  }

  if (store.state.isLogin) {
    if (
      to.path === '/login' ||
      to.path === '/register/user_category' ||
      to.path === '/password'
    ) {
      next({ path: '/' })
    }
  }

  let title = ''
  let desc: string | null = ''

  if (Object.keys(to.meta).length) {
    if (to.meta.title) {
      title = `${to.meta.title} | ${baseTitle}`
    } else {
      title = baseTitle
    }
    if (to.meta.desc) {
      desc = `${to.meta.desc} | ${baseDesc}`
    } else {
      desc = ''
    }
  } else {
    title = baseTitle
    desc = baseDesc
  }

  document.title = title

  if (desc && metaDesc) {
    metaDesc.setAttribute('content', desc)
  } else if (desc === '' && metaDesc) {
    metaDesc.setAttribute('content', '')
  }

  next()
})

router.afterEach(() => {
  if (!store.state.isInitialized || store.state.visibleLoading)
    store.commit('closeLoading')
})

export default router
